<template>
  <div class="container flex flex-col justify-center min-h-full px-6 py-8 mx-auto">
    <h3 class="text-3xl font-medium text-center text-gray-700">Not found</h3>
    <p class="mt-2 font-mono text-sm text-center text-gray-500">
      Page not found, go back to continue
    </p>
  </div>
</template>

<script setup lang="ts">

</script>
